import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import React, {useLayoutEffect, useRef, useState} from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { permissionObj } from '../../../../Helpers/permission';
import {RESERVATIONS_SUB_VIEW_MODEL, TABS_RESERVATIONS} from '../Model/Model';
import { MODELS } from '../../../../Apis/Models';
import { TABLES } from '../../../../Apis/Tables';
import routes from '../../../../Routes/routes';

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 */
export const ReservationsMainApp = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const reservationRef = useRef();
    const manageRef = useRef();
    let { state } = location;
    const currentTab = state?.currentTab;
    const isTabRequestedByNavigation = currentTab !== null && typeof currentTab !== 'undefined';
    const currentSubView = state?.currentSubView;

    const userId = useSelector((state) => state.authenticatioauthennSlice.getUserByIdAtEntry.userId);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    const [moduleId, setModuleId] = useState(MODELS.Event);
    const [option, setOption] = useState(TABLES.EVENT);

    const [steps, setSteps] = useState([]);
    const [activeStep, setActiveStep] = useState(0);

    const [selectedList, setSelectedList] = useState([]);

    const [search, setSearch] = useState(false);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [sendSimpleSearch, setSendSimpleSearch] = useState(false);

    const [bodyForExport, setBodyForExport] = useState('');
    const [searchElement, setSearchElement] = useState('');
    const [subView, setSubView] = useState(null);

    useLayoutEffect(() => {
        let activeTab = null;
        const stepConfig = [
            { tab: TABS_RESERVATIONS.BOOKINGS.TRANS, perm: [permissionObj?.WEB_EVENT_READ, permissionObj?.WEB_EVENT_STATUS_READ], index: TABS_RESERVATIONS.BOOKINGS.INDEX },
            { tab: TABS_RESERVATIONS.MANAGE.TRANS, perm: [permissionObj?.WEB_EVENT_MANAGE_READ], index: TABS_RESERVATIONS.MANAGE.INDEX },
        ];

        const auxStep = stepConfig.reduce((acc, { tab, perm, index }) => {
            const hasPermission = DEV || perm.some(p => permission?.includes(p));
            if (hasPermission) {
                acc.push({ label: t(tab), index: index });
                if (activeTab === null) activeTab = index;
            }
            return acc;
        }, []);

        setSteps(auxStep);

        // The tab asked for by the navigation state is a view of its own: without permission for it
        // the reader goes to the forbidden page instead of landing on a tab that is not in the list.
        if (auxStep.length > 0 && isTabRequestedByNavigation && !auxStep.some(({ index }) => index === currentTab)) {
            navigate(routes.forbidden);
            return;
        }

        if (activeTab !== null && !isTabRequestedByNavigation) handleStepChange(activeTab);
    }, [t, permission]);

    useLayoutEffect(() => {
        if (!isTabRequestedByNavigation || steps.length === 0) return;
        // Same rule as the tab initialization: a tab the role cannot see is a forbidden view.
        if (!steps.some(({ index }) => index === currentTab)) {
            navigate(routes.forbidden);
            return;
        }
        handleStepChange(currentTab);
    }, [location, steps]);

    const handleStepChange = (step) => {
        setActiveStep(step);
        setSelectedList([]);
        setSearchElement('');
        setSearch(false);
        navigate(location.pathname, { replace: true, state: {} });
        subViewChange(step);

        switch (step) {
            case TABS_RESERVATIONS.BOOKINGS.INDEX:
                setModuleId(MODELS.Event);
                setOption(TABLES.EVENT);
                break;
            case TABS_RESERVATIONS.MANAGE.INDEX:
                setModuleId(22222222); // changeModule
                setOption("changeOption"); // changeOption
                break;
        }
    };

    // Determines the subview to load for a specific tab
    const subViewChange = (step) => {

        let subView;
        switch (step) {
            case TABS_RESERVATIONS.BOOKINGS.INDEX:
                const request = DEV || permission?.includes(permissionObj.WEB_EVENT_READ)
                const status  = DEV || permission?.includes(permissionObj.WEB_EVENT_STATUS_READ);

                if (currentSubView === RESERVATIONS_SUB_VIEW_MODEL.BOOKINGS.REQUEST || request){
                    subView = currentSubView || RESERVATIONS_SUB_VIEW_MODEL.BOOKINGS.REQUEST;
                    setModuleId(MODELS.Event);
                    setOption(TABLES.EVENT);
                }
                else if ( currentSubView === RESERVATIONS_SUB_VIEW_MODEL.BOOKINGS.STATUS || status){
                    subView  = currentSubView || RESERVATIONS_SUB_VIEW_MODEL.BOOKINGS.STATUS;
                    setModuleId(MODELS.EVENT_STATUS);
                    setOption(TABLES.EVENT_STATUS);
                }

                setSubView(subView);
                break;
        }
    };

    const permissionButtons = (list) => {
        const permissionRequired = list[activeStep];

        if (!permissionRequired) {
            return false;
        }
        return DEV || permission?.includes(permissionRequired);
    };

    const handleCreate = () => {
        switch (activeStep) {
            case TABS_RESERVATIONS.BOOKINGS.INDEX:
                navigate(routes.event.create);
                break;
        }
    };

    const handleUpdate = () => {
        switch (activeStep) {
            case TABS_RESERVATIONS.MANAGE.INDEX:
                if (manageRef.current)
                    manageRef.current.handleUpdate();
                break;
        }
    };


    return {
        t,
        DEV,
        dispatch,
        userId,
        permission,
        navigate,
        manageRef,
        reservationRef,
        option, setOption,
        moduleId, setModuleId,
        steps, setSteps,
        activeStep, setActiveStep,
        subView , setSubView,
        selectedList, setSelectedList,
        search, setSearch,
        simpleSearch, setSimpleSearch,
        sendSimpleSearch, setSendSimpleSearch,
        bodyForExport, setBodyForExport,
        searchElement, setSearchElement, 
        handleStepChange,
        permissionButtons,
        handleCreate,
        handleUpdate,
    };
};
